<template>
  <div>
    <el-form
        label-width="140px"
        :model="createStudentNotify"
        label-position="left"
        :rules="rules"
        ref="createStudentNotify"
    >
      <el-row :gutter="40">
        <el-col :span="24">
          <div class="grid-content">
            <el-form-item label="Nội dung:" prop="sendContent">
              <el-input
                  disabled
                  :rows="7"
                  type="textarea"
                  placeholder="Nhập nội dung..."
                  v-model="createStudentNotify.sendContent"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="tab-info-button">
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm('createStudentNotify')"
      >
        <i class="el-icon-circle-check"/>
        <span>Gửi</span>
      </el-button>
      <el-button
          type="danger"
          size="medium"
          @click="closeForm"
      >
        <i class="el-icon-circle-close"/>
        <span>Đóng</span>
      </el-button>
    </div>
  </div>
</template>

<script>

import operationPackage from "@/services/PackageService/OperationPackage";
import {mapState} from "vuex";

export default {
  data() {
    return {
      createStudentNotify: {
        sendContent: "",
      },
      loadingButton: false,
      rules: {
        sendContent: [
          {
            required: true,
            message: "Nội dung không được để trống",
            trigger: "blur",
          },
        ],
      },
      requestSendSms: {
        listKids: [],
      }
    }
  },
  created() {
    this.createDataNotify();
  },
  computed: {
    ...mapState("packageStore", [
      "idKidList", "managerTuitionId", "listKidsRequest"
    ]),
  },
  methods: {
    closeForm() {
      this.$emit('closeDialogSendSms');
    },

    submitForm() {
      const param = {
        listKids: this.requestSendSms.listKids,
      }
      this.$confirm(
          'Số lượng tin nhắn sẽ bị trừ vào quỹ tin của NHÀ TRƯỜNG! <br> Bạn có chắc chắn muốn gửi không?',
          'Thông báo!',
          {
            confirmButtonText: 'Có',
            cancelButtonText: 'Không',
            dangerouslyUseHTMLString: true
          })
          .then(() => {
            operationPackage.sendSms(param)
                .then((res) => {
                  this.$message({
                    type: 'success',
                    message: res.data.message
                  });
                })
                .catch((err) => {
                  console.log(err.message);
                })
                .finally(() => {
                  this.closeForm();
                })
          })
    },

    async createDataNotify() {
      await operationPackage.getTextSample().then((res) => {
        this.createStudentNotify.sendContent = res.data.data.content;
      });

      this.requestSendSms.listKids = this.listKidsRequest;
    },
  }
}
</script>

<style>

.tab-info-button {
  display: flex;
  justify-content: end;
}
</style>